export { MainSliderCatalog } from './MainSliderCatalog';
    